import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

const GOLD = "text-amber-400 fill-amber-400";

export function StarIcon({ className }: { className?: string }) {
  return <Star className={cn("h-3 w-3 shrink-0", GOLD, className)} aria-hidden />;
}
